module.exports = __webpack_public_path__ + "img/icon-advt-tax.77efe87e.svg";